"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataPositionProp = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Utility function to generate the `data-position` attribute with the right values in the right order.
 * The current version of cobalt.css only supports the positions on this specific order. In other words: `left center` works but `center left` doesn't.
 * @returns An object with the data attribute name and value.
 */
var getDataPositionProp = function getDataPositionProp(_ref) {
  var bottom = _ref.bottom,
      center = _ref.center,
      left = _ref.left,
      right = _ref.right,
      top = _ref.top;
  var possiblePositions = {
    bottom: bottom,
    top: top,
    right: right,
    left: left,
    center: center
  };
  var finalPositions = Object.keys(possiblePositions).reduce(function (positions, position) {
    return possiblePositions[position] ? [].concat(_toConsumableArray(positions), [position]) : positions;
  }, []);
  return finalPositions.length > 0 ? {
    'data-position': finalPositions.join(' ')
  } : {};
};

exports.getDataPositionProp = getDataPositionProp;